import { render, staticRenderFns } from "./DelegationEdit.vue?vue&type=template&id=49ab5239&scoped=true&"
import script from "./DelegationEdit.vue?vue&type=script&lang=js&"
export * from "./DelegationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ab5239",
  null
  
)

export default component.exports